<script>
  import { query } from "svelte-apollo";
  import gql from "graphql-tag";

  import { client as apolloClient } from "apollo.js";
  import { client } from "sanityClient.js";
  import { currentLang } from "stores.js";

  import UserData from "components/UserData.svelte";
  import EventList from "components/EventList.svelte";

  const ME_QUERY = gql`
    query ME_QUERY {
      me {
        id
        firstName
        lastName
        email
        function
        party
        canton
      }
      myRegistrations {
        id
        sanityEventId
      }
    }
  `;

  const EDIT_USER_DATA_MUTATION = gql`
    mutation($userData: UserData!) {
      editUserData(userData: $userData) {
        id
        firstName
        lastName
        email
        function
        party
        canton
      }
    }
  `;

  const UNREGISTER_FROM_EVENT = gql`
    mutation($eventId: ID!, $currentLang: String!) {
      unregisterFromEvent(eventId: $eventId, currentLang: $currentLang) {
        id
      }
    }
  `;

  const eventQuery = '*[_type == "event"] {_id, title}';
  const params = {};
  const events = client.fetch(eventQuery, params);

  const editUserData = async (userData) => {
    const result = await apolloClient.mutate({
      mutation: EDIT_USER_DATA_MUTATION,
      variables: { userData: userData },
    });
    return result;
  };

  const unregisterFromEvent = async (eventId, currentLang) => {
    const result = await apolloClient.mutate({
      mutation: UNREGISTER_FROM_EVENT,
      variables: { eventId, currentLang },
    });
    return result;
  };

  const me = query(apolloClient, { query: ME_QUERY });

  const handleSave = (e) => {
    const { data } = e.detail;

    const userData = {
      firstName: data.name,
      lastName: data.surname,
      function: data.role,
      party: data.party,
      canton: data.canton,
    };

    try {
      editUserData(userData);
    } catch (e) {
      console.error(e);
    }
  };

  const handleUnregister = (e) => {
    const { eventId } = e.detail;

    try {
      unregisterFromEvent(eventId, $currentLang).then(() => {
        me.refetch();
      });
    } catch (e) {
      console.error(e);
    }
  };

  const myEvents = (events, myRegistrations) => {
    return events.filter((event) => {
      const registration = myRegistrations.find(
        (r) => r.sanityEventId == event._id
      );
      return !!registration;
    });
  };
</script>

<div class="wrapper">
  {#await $me}
    <p>Loading...</p>
  {:then result}
    {#await events then events}
      <UserData on:save={handleSave} user={result.data.me} />
      <EventList
        on:unregister={handleUnregister}
        events={myEvents(events, result.data.myRegistrations)}
      />
    {/await}
  {:catch error}
    <p>ERROR: {error}</p>
  {/await}
</div>

<style>
  .wrapper {
    margin: 48px 0;
  }
</style>
